// extracted by mini-css-extract-plugin
export var item = "fk_tw";
export var text = "fk_hy";